<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
  Rediger adgangsgrupper
</h2>
<button type="button" class="btn-close btn-icon" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  @if (accessGroups$ | async; as accessGroups) {
    @if (filteredAccessGroups$ | async; as filteredAccessGroups) {
      @if (filteredAccessGroups.length === 0 || accessGroups.length === 0) {
        <ok-feedback-info>
          <div>
            Organisationen har ingen tilgængelige adgangsgrupper. Tilknyt en adgangsgruppe til organisationen for at kunne tilføje
            adgangsgrupper til brugeren.
          </div>
        </ok-feedback-info>
      }
      @if (accessGroups.length > 0) {
        <div class="form-row form-row--multi-select nolimits">
          <div class="multi-select">
            <div class="multi-select__list multi-select__list--grid">
              @if (accessGroupUsers$ | async; as accessGroupUsers) {
                @if (accessGroupUsers.length > 0) {
                  <div class="multi-select__headers">
                    <div class="multi-select__item--name">
                      <strong>Navn</strong>
                    </div>
                    <div class="multi-select__item--discount">
                      <strong>Rabat</strong>
                    </div>
                    <div class="multi-select__item--discount">
                      <strong>Tidsbegrænset</strong>
                    </div>
                    <div></div>
                  </div>
                }
                @for (accessGroup of accessGroupUsers; track accessGroup; let i = $index) {
                  <div
                    class="multi-select__item multi-select__item--tall"
                    [class.highlight]="accessGroup.chargingUserIdentifier === accessGroupUserAddedIdentifier">
                    <div class="multi-select__item-title">
                      <span>&nbsp;{{ accessGroup.name }}</span>
                    </div>
                    <div class="multi-select__item-title">
                      @if (accessGroup.discountType === discountType.FixedAmount) {
                        <span>{{ accessGroup.amount | dkCurrency }}</span>
                      }
                      @if (accessGroup.discountType === discountType.Percentages) {
                        <span>{{ accessGroup.amount | number: '1.2-2' }}%</span>
                      }
                    </div>
                    <div class="multi-select__item-title">
                      @if (accessGroup.accessType === accessGroupUserType.TimeLimited) {
                        <span class="icon-with-text">
                          <mat-icon
                            class="margin--left-xs cursor-help"
                            matTooltip="Brugeren har adgang fra {{ accessGroup.timeLimitedFrom | date: 'shortDate' }} til og med {{
                              accessGroup.timeLimitedTo | date: 'shortDate'
                            }}">
                            update
                          </mat-icon>
                          {{ accessGroup.timeLimitedFrom | date: 'shortDate' }} - {{ accessGroup.timeLimitedTo | date: 'shortDate' }}
                        </span>
                      }
                      @if (accessGroup.accessType === accessGroupUserType.Permanent) {
                        <span>Nej</span>
                      }
                    </div>
                    <button mat-icon-button class="delete" title="Fjern" type="button" (click)="deleteAccessGroupUser(accessGroup)">
                      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                    </button>
                  </div>
                }
              }
              @if (filteredAccessGroups.length !== 0) {
                <div class="multi-select__input">
                  @if (accessGroupUserCreateModel) {
                    <form class="filter-dropdown" [formGroup]="accessGroupUserCreateModel">
                      <mat-form-field>
                        <mat-label>Vælg adgangsgruppe</mat-label>
                        <div>
                          <input type="text" formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
                        </div>
                        <mat-autocomplete
                          #auto="matAutocomplete"
                          hideSingleSelectionIndicator="true"
                          [displayWith]="accessGroupDisplayFn"
                          (optionSelected)="onAccessGroupChange($event)"
                          okCustomDropDownArrowDirective>
                          @for (accessGroup of filteredAccessGroups; track accessGroup) {
                            <mat-option [value]="accessGroup" class="price-policy-item">
                              <strong class="icon-with-text">
                                {{ accessGroup.name }}
                              </strong>
                              <span>{{ accessGroup.organizationName }}</span>
                            </mat-option>
                          }
                        </mat-autocomplete>
                        @if (this.selectedAccessGroupIdentifier.value) {
                          <mat-icon matSuffix class="clear-input-field-button" (click)="resetAccessGroup()"> close </mat-icon>
                        }
                        <mat-icon matSuffix></mat-icon>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Tidsbegrænset</mat-label>
                        <mat-select
                          formControlName="timeLimited"
                          (selectionChange)="onTimeLimitedChange($event)"
                          okCustomDropDownArrowDirective>
                          <mat-option [value]="true">Ja</mat-option>
                          <mat-option [value]="false">Nej</mat-option>
                        </mat-select>
                        <mat-icon matSuffix></mat-icon>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Periode</mat-label>
                        <mat-date-range-input
                          [rangePicker]="picker"
                          (click)="picker.open()"
                          [dateFilter]="rangeFilter"
                          [disabled]="!this.accessGroupCreateTimelimited.value">
                          <input
                            matInput
                            formControlName="startDate"
                            class="pointer"
                            readonly
                            matStartDate
                            placeholder="Start dato"
                            #dateRangeStart />
                          <input
                            matInput
                            formControlName="endDate"
                            class="pointer"
                            readonly
                            matEndDate
                            placeholder="Slut dato"
                            #dateRangeEnd />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                      <button
                        mat-flat-button
                        color="primary"
                        title="Tilføj"
                        (click)="createAccessGroupUser()"
                        class="add-button"
                        [disabled]="saving || accessGroupUserCreateModel.invalid"
                        [class.spinner]="saving">
                        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
                      </button>
                    </form>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <div class="unit-identifier">
    <span>Bruger:</span>
    {{ chargingUser.name }}
  </div>
  <button type="button" mat-stroked-button (click)="close()">Luk</button>
</mat-dialog-actions>
